import React, { useState, useEffect } from 'react';
import './style2.css';
import Paper from '@material-ui/core/Paper';
import Logo from '../../assets/zelao.png';
import axios from 'axios';
import { Formik } from 'formik';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import HeaderRelatorio from './HeaderRelatorio';
import { ProgressSpinner } from 'primereact/progressspinner';
import moment from 'moment/min/moment-with-locales';
import {
    InscricaoBody,
    AssociadoBody,
    TipoBody,
    bodyTotalComissaoGerente,
    bodyTotalComissaoCoordenador,
    bodyPagamento,
    bodyTotalComissaoSupervisor,
    bodyValorComissaoVendedor,
    bodyValorPagoVendedor,
    bodyComissaoCoordenador,
    bodyCommissaoVendedor
} from './bodyTemplate';
import './Css/DataTableDemo.css';
import { decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';
import { retornoHashValor } from '../../modulos/cripotografia/hash';

export default function RelatorioGerente({ history }) {
    const [value, setValue] = useState(false);
    const [loading, setLoading] = useState(false);

    const [gerente, setGerente] = useState(false);

    const [showGerente, setShowGerente] = useState(false);

    const [dataInicial, setDataInicial] = useState('');
    const [dataFinal, setDataFinal] = useState('');

    const [expandedRows, setExpandedRows] = useState(null);
    const [expandedRows2, setExpandedRows2] = useState(null);
    const [expandedRows3, setExpandedRows3] = useState(null);

    const [totalAdesaoPagas, setTotalAdesaoPagas] = useState('');
    const [totalMensalPagas, setTotalMensalPagas] = useState('');
    const [lengthAdesaoGeral, setLengthAdesaoGeral] = useState('');
    const [lengthMensalGeral, setLengthMensalGeral] = useState('');

    const tipagem = 'gerente';

    const api = axios.create({
        baseURL: retornoHashValor(process.env.REACT_APP_7)
    });

    const codigo = decriptoLocalStorage('codigo_vendedor')?.decriptoValue;

    let areaColaborador;
    const nomeUsuario = decriptoLocalStorage('Nome')?.decriptoValue;
    const area = decriptoLocalStorage('area');

    switch (area) {
    case '1':
        areaColaborador = 'EXTERNO';
        break;
    case null:
        areaColaborador = 'EXTERNO';
        break;
    case '2':
        areaColaborador = 'TELEMARKETING';
        break;
    case '3':
        areaColaborador = 'PRIME';
        break;
    case '4':
        areaColaborador = 'PDV';
        break;
    case '5':
        areaColaborador = 'TERCEIRIZADO';
        break;
    default:
        areaColaborador = 'PRIME';
    }

    useEffect(() => {
        const handleSubmit = async () => {
            setLoading(true);

            const dateInicio = moment().format('01-MM-YYYY');
            const dateFim = moment().format('DD-MM-YYYY');

            const body = {
                codigo,
                data_inicio: moment().format('YYYY-MM-01'),
                data_fim: moment().format('YYYY-MM-DD'),
                tipo: areaColaborador
            };

            setDataInicial(dateInicio);
            setDataFinal(dateFim);

            const response = await api
                .post(`/relatorio/${tipagem}`, body)
                .then(resp => {
                    const vendedores =
                        resp.data[Object.keys(resp.data)[0]].vendas;

                    setValue(vendedores);
                    setShowGerente(tipagem === 'gerente');
                    setLoading(false);
                })
                .catch(err => {
                    console.log(err);
                });
        };

        handleSubmit();
    }, [tipagem]);

    const initialValues = {
        codigo: '',
        data_inicio: '',
        data_fim: '',
        tipo: '',
        tipagem: ''
    };

    moment.locale('pt-br');

    const dataTitle = moment(new Date(), ['DD%MM%YYYY']).format('MMMM YYYY');
    const dataSubTitle = moment(new Date(), ['DD%MM%YYYY']).format(
        'DD/MM/YYYY'
    );
    const timeSubTitle = moment(new Date()).format(' HH:mm');

    const formatCurrency = value => value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    });

    const expandirGerentes = () => {
        //let _expandirGerente = {};
        const _expandirCoordenador = {};
        const _expandirSupervisor = {};
        const _expandirVendedor = {};

        //gerente.forEach((p) => (_expandirGerente[`${p.NomeGerente}`] = true));
        gerente.forEach(p =>
            p.Vendas.forEach(
                vendas =>
                    (_expandirCoordenador[`${vendas.NomeCoordenador}`] = true)
            )
        );
        gerente.forEach(p =>
            p.Vendas.forEach(
                vendas =>
                    (_expandirSupervisor[`${vendas.NomeSupervisor}`] = true)
            )
        );

        setExpandedRows(_expandirCoordenador);
        setExpandedRows2(_expandirSupervisor);
    };

    const fecharGerente = () => {
        setExpandedRows(null);
        setExpandedRows2(null);
        setExpandedRows3(null);
    };

    let somaTipoMensalGeral = 0;
    let somaTipoAdesaoGeral = 0;
    const lengthVendasMensalGeral = [];
    const lengthVendasAdesaoGeral = [];
    const porcentagemMensal = 1.5;
    const porcentagemAdesao = 3.0;

    // const headerGerente = (
    //     <div className="table-header-container">
    //     </div>
    // );

    if (showGerente) {
        if (!gerente) {
            const arrayGerente = [];

            //for que divide os contratos entre mensalidade e adesão do gerente e todos
            for (const i in value) {
                if (value[i].Tipo == 'Mensalidades') {
                    somaTipoMensalGeral += value[i].ValorPago;
                    lengthVendasMensalGeral.push(value[i].length);
                }

                if (value[i].Tipo == 'Adesao') {
                    somaTipoAdesaoGeral += value[i].ValorPago;
                    lengthVendasAdesaoGeral.push(value[i].length);
                }
            }

            setTotalAdesaoPagas(somaTipoMensalGeral);
            setTotalMensalPagas(somaTipoAdesaoGeral);
            setLengthAdesaoGeral(lengthVendasAdesaoGeral.length);
            setLengthMensalGeral(lengthVendasMensalGeral.length);

            for (let i = 0; i < value.length; i++) {
                let arrayIgual = false;

                for (let j = 0; j < i; j++) {
                    if (
                        arrayGerente[j] &&
                        value[i].NomeGerente === arrayGerente[j].NomeGerente
                    ) {
                        arrayGerente[j].Vendas.push({
                            Id: value[i].Id,
                            Tipo: value[i].Tipo,
                            Inscricao: value[i].Inscricao,
                            Pagamento: value[i].Pagamento,
                            Descricao: value[i].Descricao,
                            ValorPago: value[i].ValorPago,
                            NomeGerente: value[i].NomeGerente,
                            nomeVendedor: value[i].nomeVendedor,
                            NomeAssociado: value[i].NomeAssociado,
                            ValorComissao: value[i].ValorComissao,
                            NomeSupervisor: value[i].NomeSupervisor,
                            NomeCoordenador: value[i].NomeCoordenador,
                            PercentualComissao: value[i].PercentualComissao,
                            ValorComissaoGerente: value[i].ValorComissaoGerente,
                            ValorComissaoSupervisor:
                                value[i].ValorComissaoSupervisor,
                            ValorComissaoCoordenador:
                                value[i].ValorComissaoCoordenador
                        });
                        arrayIgual = true;

                        arrayGerente[j].TotalComissaoGerente +=
                            value[i].ValorComissaoGerente;
                        arrayGerente[j].TotalComissaoSupervisor +=
                            value[i].ValorComissaoSupervisor;
                        arrayGerente[j].TotalComissaoCoordenador +=
                            value[i].ValorComissaoCoordenador;

                        break;
                    }
                }

                if (!arrayIgual) {
                    arrayGerente.push({
                        Id: value[i].Id,
                        Tipo: value[i].Tipo,
                        Descricao: value[i].Descricao,
                        NomeGerente: (value[i].NomeGerente = nomeUsuario),
                        nomeVendedor: value[i].nomeVendedor,
                        NomeSupervisor: value[i].NomeSupervisor,
                        NomeCoordenador: value[i].NomeCoordenador,
                        TotalComissaoGerente: value[i].ValorComissaoGerente,
                        TotalComissaoSupervisor:
                            value[i].ValorComissaoSupervisor,
                        TotalComissaoCoordenador:
                            value[i].ValorComissaoCoordenador,
                        Vendas: [
                            {
                                Id: value[i].Id,
                                Inscricao: value[i].Inscricao,
                                Pagamento: value[i].Pagamento,
                                Descricao: value[i].Descricao,
                                ValorPago: value[i].ValorPago,
                                nomeVendedor: value[i].nomeVendedor,
                                ValorComissao: value[i].ValorComissao,
                                NomeAssociado: value[i].NomeAssociado,
                                PercentualComissao: value[i].PercentualComissao,
                                ValorComissaoGerente:
                                    value[i].ValorComissaoGerente,
                                ValorComissaoSupervisor:
                                    value[i].ValorComissaoSupervisor,
                                ValorComissaoCoordenador:
                                    value[i].ValorComissaoCoordenador
                            }
                        ]
                    });
                }
            }

            setGerente(arrayGerente);
        }
    }

    const coordenadorTemplate = data => {
        const arrayCoordenador = [];

        for (let i = 0; i < data.Vendas.length; i++) {
            let arrayIgual = false;

            for (let j = 0; j < i; j++) {
                if (
                    arrayCoordenador[j] &&
                    data.Vendas[i].NomeCoordenador ==
                        arrayCoordenador[j].NomeCoordenador
                ) {
                    arrayCoordenador[j].Vendas.push({
                        Id: data.Vendas[i].Id,
                        Tipo: data.Vendas[i].Tipo,
                        Inscricao: data.Vendas[i].Inscricao,
                        Descricao: data.Vendas[i].Descricao,
                        Pagamento: data.Vendas[i].Pagamento,
                        ValorPago: data.Vendas[i].ValorPago,
                        NomeGerente: data.Vendas[i].NomeGerente,
                        nomeVendedor: data.Vendas[i].nomeVendedor,
                        NomeAssociado: data.Vendas[i].NomeAssociado,
                        ValorComissao: data.Vendas[i].ValorComissao,
                        NomeSupervisor: data.Vendas[i].NomeSupervisor,
                        NomeCoordenador: data.Vendas[i].NomeCoordenador,
                        PercentualComissao: data.Vendas[i].PercentualComissao,
                        ValorComissaoSupervisor:
                            data.Vendas[i].ValorComissaoSupervisor,
                        ValorComissaoCoordenador:
                            data.Vendas[i].ValorComissaoCoordenador
                    });
                    arrayIgual = true;
                    arrayCoordenador[j].TotalComissaoSupervisor +=
                        data.Vendas[i].ValorComissaoSupervisor;
                    arrayCoordenador[j].TotalComissaoCoordenador +=
                        data.Vendas[i].ValorComissaoCoordenador;
                    break;
                }
            }

            if (!arrayIgual) {
                arrayCoordenador.push({
                    Descricao: data.Vendas[i].Descricao,
                    NomeSupervisor: data.Vendas[i].NomeSupervisor,
                    NomeCoordenador: data.Vendas[i].NomeCoordenador,
                    TotalComissaoSupervisor:
                        data.Vendas[i].ValorComissaoSupervisor,
                    TotalComissaoCoordenador:
                        data.Vendas[i].ValorComissaoCoordenador,
                    Vendas: [
                        {
                            Id: data.Vendas[i].Id,
                            Tipo: data.Vendas[i].Tipo,
                            Inscricao: data.Vendas[i].Inscricao,
                            Descricao: data.Vendas[i].Descricao,
                            Pagamento: data.Vendas[i].Pagamento,
                            ValorPago: data.Vendas[i].ValorPago,
                            nomeVendedor: data.Vendas[i].nomeVendedor,
                            ValorComissao: data.Vendas[i].ValorComissao,
                            NomeAssociado: data.Vendas[i].NomeAssociado,
                            NomeSupervisor: data.Vendas[i].NomeSupervisor,
                            NomeCoordenador: data.Vendas[i].NomeCoordenador,
                            PercentualComissao:
                                data.Vendas[i].PercentualComissao,
                            ValorComissaoSupervisor:
                                data.Vendas[i].ValorComissaoSupervisor,
                            ValorComissaoCoordenador:
                                data.Vendas[i].ValorComissaoCoordenador
                        }
                    ]
                });
            }
        }

        return (
            <div className="orders-subtable">
                <DataTable
                    value={arrayCoordenador}
                    onRowToggle={e => setExpandedRows2(e.data)}
                    expandedRows={expandedRows2}
                    rowExpansionTemplate={supervisorTemplate}
                    dataKey="NomeCoordenador"
                    footer=""
                >
                    <Column expander style={{ width: '3em' }} />
                    <Column field="NomeCoordenador" header="Coordenadores" />
                    <Column
                        field="TotalComissaoCoordenador"
                        header="Comissão Coordenadores"
                        body={bodyTotalComissaoCoordenador}
                    />
                </DataTable>
            </div>
        );
    };

    const supervisorTemplate = data => {
        const novoArray = [];

        for (let i = 0; i < data.Vendas.length; i++) {
            let arrayIgual = false;

            for (let j = 0; j < i; j++) {
                if (
                    novoArray[j] &&
                    data.Vendas[i].NomeSupervisor == novoArray[j].NomeSupervisor
                ) {
                    novoArray[j].Vendas.push({
                        Id: data.Vendas[i].Id,
                        Tipo: data.Vendas[i].Tipo,
                        Inscricao: data.Vendas[i].Inscricao,
                        Descricao: data.Vendas[i].Descricao,
                        Pagamento: data.Vendas[i].Pagamento,
                        ValorPago: data.Vendas[i].ValorPago,
                        nomeVendedor: data.Vendas[i].nomeVendedor,
                        ValorComissao: data.Vendas[i].ValorComissao,
                        NomeAssociado: data.Vendas[i].NomeAssociado,
                        NomeSupervisor: data.Vendas[i].NomeSupervisor,
                        NomeCoordenador: data.Vendas[i].NomeCoordenador,
                        PercentualComissao: data.Vendas[i].PercentualComissao,
                        ValorComissaoSupervisor:
                            data.Vendas[i].ValorComissaoSupervisor,
                        ValorComissaoCoordenador:
                            data.Vendas[i].ValorComissaoCoordenador
                    });
                    arrayIgual = true;
                    novoArray[j].TotalComissaoSupervisor +=
                        data.Vendas[i].ValorComissaoSupervisor;
                    break;
                }
            }

            if (!arrayIgual) {
                novoArray.push({
                    Descricao: data.Vendas[i].Descricao,
                    NomeSupervisor: data.Vendas[i].NomeSupervisor,
                    NomeCoordenador: data.Vendas[i].NomeCoordenador,
                    TotalComissaoSupervisor:
                        data.Vendas[i].ValorComissaoSupervisor,
                    Vendas: [
                        {
                            Id: data.Vendas[i].Id,
                            Tipo: data.Vendas[i].Tipo,
                            Inscricao: data.Vendas[i].Inscricao,
                            Descricao: data.Vendas[i].Descricao,
                            Pagamento: data.Vendas[i].Pagamento,
                            ValorPago: data.Vendas[i].ValorPago,
                            nomeVendedor: data.Vendas[i].nomeVendedor,
                            ValorComissao: data.Vendas[i].ValorComissao,
                            NomeAssociado: data.Vendas[i].NomeAssociado,
                            NomeSupervisor: data.Vendas[i].NomeSupervisor,
                            NomeCoordenador: data.Vendas[i].NomeCoordenador,
                            PercentualComissao:
                                data.Vendas[i].PercentualComissao,
                            ValorComissaoSupervisor:
                                data.Vendas[i].ValorComissaoSupervisor,
                            ValorComissaoCoordenador:
                                data.Vendas[i].ValorComissaoCoordenador
                        }
                    ]
                });
            }
        }

        return (
            <div className="orders-subtable">
                <DataTable
                    value={novoArray}
                    onRowToggle={e => setExpandedRows2(e.data)}
                    expandedRows={expandedRows2}
                    rowExpansionTemplate={vendedoresTemplate}
                    dataKey="NomeSupervisor"
                    footer=""
                >
                    <Column expander style={{ width: '3em' }} />
                    <Column field="NomeSupervisor" header="Supervisores" />
                    <Column
                        field="TotalComissaoSupervisor"
                        header="Comissão Supervisor"
                        body={bodyTotalComissaoSupervisor}
                    />
                </DataTable>
            </div>
        );
    };

    const vendedoresTemplate = data => {
        const novoArray = [];

        for (let i = 0; i < data.Vendas.length; i++) {
            let arrayIgual = false;

            for (let j = 0; j < i; j++) {
                if (
                    novoArray[j] &&
                    data.Vendas[i].nomeVendedor == novoArray[j].nomeVendedor
                ) {
                    novoArray[j].Vendas.push({
                        Id: data.Vendas[i].Id,
                        Tipo: data.Vendas[i].Tipo,
                        Inscricao: data.Vendas[i].Inscricao,
                        Pagamento: data.Vendas[i].Pagamento,
                        ValorPago: data.Vendas[i].ValorPago,
                        Descricao: data.Vendas[i].Descricao,
                        nomeVendedor: data.Vendas[i].nomeVendedor,
                        NomeSupervisor: data.Vendas[i].nomeVendedor,
                        ValorComissao: data.Vendas[i].ValorComissao,
                        NomeAssociado: data.Vendas[i].NomeAssociado,
                        PercentualComissao: data.Vendas[i].PercentualComissao,
                        ValorComissaoSupervisor:
                            data.Vendas[i].ValorComissaoSupervisor,
                        ValorComissaoCoordenador:
                            data.Vendas[i].ValorComissaoCoordenador
                    });
                    arrayIgual = true;
                    novoArray[j].TotalComissao += data.Vendas[i].ValorComissao;
                    novoArray[j].TotalComissaoSupervisor +=
                        data.Vendas[i].ValorComissaoSupervisor;

                    break;
                }
            }

            if (!arrayIgual) {
                novoArray.push({
                    nomeVendedor: data.Vendas[i].nomeVendedor,
                    TotalComissao: data.Vendas[i].ValorComissao,
                    TotalComissaoSupervisor:
                        data.Vendas[i].ValorComissaoSupervisor,
                    Descricao: data.Vendas[i].Descricao,
                    Vendas: [
                        {
                            Id: data.Vendas[i].Id,
                            Tipo: data.Vendas[i].Tipo,
                            Inscricao: data.Vendas[i].Inscricao,
                            Pagamento: data.Vendas[i].Pagamento,
                            ValorPago: data.Vendas[i].ValorPago,
                            Descricao: data.Vendas[i].Descricao,
                            nomeVendedor: data.Vendas[i].nomeVendedor,
                            ValorComissao: data.Vendas[i].ValorComissao,
                            NomeAssociado: data.Vendas[i].NomeAssociado,
                            NomeSupervisor: data.Vendas[i].NomeSupervisor,
                            PercentualComissao:
                                data.Vendas[i].PercentualComissao,
                            ValorComissaoSupervisor:
                                data.Vendas[i].ValorComissaoSupervisor,
                            ValorComissaoCoordenador:
                                data.Vendas[i].ValorComissaoCoordenador
                        }
                    ]
                });
            }
        }

        return (
            <div className="orders-subtable">
                <DataTable
                    value={novoArray}
                    onRowToggle={e => setExpandedRows3(e.data)}
                    expandedRows={expandedRows3}
                    rowExpansionTemplate={vendasTemplate}
                    dataKey="nomeVendedor"
                    footer=""
                >
                    <Column expander style={{ width: '3em' }} />
                    <Column field="nomeVendedor" header="Vendedor" />
                    <Column
                        field="TotalComissao"
                        header="Comissão Vendedor"
                        body={bodyCommissaoVendedor}
                    />
                </DataTable>
            </div>
        );
    };

    //-----------------------------------------------------------------------------------------------------------------------------------

    let lengthMensal = [];
    let lengthAdesao = [];
    let somaTipoMensal = 0;
    let somaTipoAdesao = 0;
    let somaTipo;
    let somaValorTotal;

    const vendasTemplate = data => {
        //for que divide os contratos entre mensalidade e adesão do vendedor
        lengthMensal = [];
        lengthAdesao = [];
        somaTipoMensal = 0;
        somaTipoAdesao = 0;

        for (const i in data.Vendas) {
            if (data.Vendas[i].Tipo == 'Mensalidades') {
                lengthMensal.push(data.Vendas[i].length);
                somaTipoMensal += data.Vendas[i].ValorPago;
            }

            if (data.Vendas[i].Tipo == 'Adesao') {
                lengthAdesao.push(data.Vendas[i].length);
                somaTipoAdesao += data.Vendas[i].ValorPago;
            }
        }

        somaValorTotal = somaTipoAdesao + somaTipoMensal;
        somaTipo = lengthAdesao.length + lengthMensal.length;

        return (
            <DataTable
                value={data.Vendas}
                className="p-datatable-responsive-demo"
                footer={footerVendedor(data.TotalComissao)}
            >
                <Column field="Tipo" header="Tipo" body={TipoBody} />
                <Column
                    field="NomeAssociado"
                    header="Nome Associado"
                    body={AssociadoBody}
                />
                <Column
                    field="Inscricao"
                    header="Inscrição"
                    body={InscricaoBody}
                />
                <Column
                    field="Pagamento"
                    header="Pagamento"
                    body={bodyPagamento}
                />
                <Column
                    field="ValorPago"
                    header="Valor Pago"
                    body={bodyValorPagoVendedor}
                />
                <Column
                    field="ValorComissaoCoordenador"
                    header="Coordenador"
                    body={bodyComissaoCoordenador}
                />
                <Column
                    field="ValorComissao"
                    header="Valor Comissão"
                    body={bodyValorComissaoVendedor}
                />
            </DataTable>
        );
    };

    const footerVendedor = data => (
        <>
            <td className="foter_tabela_container">
                <h5 className="h5_tabela">
                    <span>
                            Registros pagos Adesão: {lengthAdesao.length}
                    </span>
                    <span>
                            Valor total pago Adesão:{' '}
                        {formatCurrency(somaTipoAdesao)}
                    </span>
                </h5>
                <h5 className="h5_tabela_meio">
                    <span>
                            Registros pagos Mensal: {lengthMensal.length}{' '}
                    </span>
                    <span>
                            valor total pagos de mensalidade:{' '}
                        {formatCurrency(somaTipoMensal)}{' '}
                    </span>
                </h5>
                <h5 className="h5_tabela_fim">
                    <span>
                            Total registros pagos por vendedor: {somaTipo}{' '}
                    </span>
                    <span>
                            Valor total pagos por vendedor:{' '}
                        {formatCurrency(somaValorTotal)}
                    </span>
                </h5>
            </td>
        </>
    );

    const totalVendas = () => {
        let totalVendas = 0;

        if (value) {
            for (const valueVendas of value) {
                if (valueVendas.nomeVendedor) {
                    totalVendas++;
                }
            }

            return totalVendas;
        }
    };

    return (
        <>
            <div className="container-relatorios">
                <Formik
                    onSubmit={''}
                    validateOnMount
                    initialValues={initialValues}
                >
                    {({
                        values,
                        handleSubmit,
                        handleChange,
                        setFieldValue
                    }) => (
                        <>
                            <Paper
                                className="paper-relatorios"
                                style={{ height: '100px' }}
                            >
                                <aside className="aside-container">
                                    <span className="title-relatorios">
                                        <strong>Relatórios {tipagem}</strong> -{' '}
                                        <span className="data-title">
                                            {dataTitle}
                                        </span>
                                    </span>
                                    <span className="subTitle-relatorios">
                                        Criado em: {dataSubTitle} às{' '}
                                        {timeSubTitle}
                                    </span>
                                </aside>
                            </Paper>
                            {loading && (
                                <div style={{ display: 'flex' }}>
                                    <ProgressSpinner
                                        style={{
                                            width: '100px',
                                            height: '100px'
                                        }}
                                        strokeWidth="1"
                                        fill="#EEEEEE"
                                        animationDuration=".5s"
                                    />
                                </div>
                            )}

                            <Paper className="paper-conteudo_relatorios  datatable-responsive-demo">
                                <div className="conteudo-relatorios">
                                    {showGerente && (
                                        <>
                                            {loading ? (
                                                <div
                                                    style={{ display: 'flex' }}
                                                >
                                                    <ProgressSpinner
                                                        style={{
                                                            width: '100px',
                                                            height: '100px'
                                                        }}
                                                        strokeWidth="1"
                                                        fill="#eeee"
                                                        animationDuration=".5s"
                                                    />
                                                </div>
                                            ) : (
                                                <>
                                                    <HeaderRelatorio
                                                        img={Logo}
                                                        title={tipagem.toUpperCase()}
                                                        vendas={totalVendas()}
                                                        dataInicio={dataInicial}
                                                        dataFim={dataFinal}
                                                        formatCurrency={
                                                            formatCurrency
                                                        }
                                                        totalMensalPagas={
                                                            totalMensalPagas
                                                        }
                                                        totalAdesaoPagas={
                                                            totalAdesaoPagas
                                                        }
                                                        lengthAdesaoGeral={
                                                            lengthAdesaoGeral
                                                        }
                                                        lengthMensalGeral={
                                                            lengthMensalGeral
                                                        }
                                                    />
                                                    {showGerente && (
                                                        <DataTable
                                                            value={gerente}
                                                            onRowToggle={e =>
                                                                setExpandedRows(
                                                                    e.data
                                                                )
                                                            }
                                                            expandedRows={
                                                                expandedRows
                                                            }
                                                            rowExpansionTemplate={
                                                                coordenadorTemplate
                                                            }
                                                            dataKey="NomeGerente"
                                                            // header={
                                                            //     headerGerente
                                                            // }
                                                            className="p-datatable-striped p-datatable-gridlines"
                                                        >
                                                            <Column
                                                                expander
                                                                style={{
                                                                    width:
                                                                        '3em'
                                                                }}
                                                            />
                                                            <Column
                                                                field="NomeGerente"
                                                                header="Gerente"
                                                                style={{
                                                                    backgroundColor:
                                                                        '#f8f9fa'
                                                                }}
                                                            />
                                                            <Column
                                                                field="TotalComissaoGerente"
                                                                header="Comissão Gerente"
                                                                body={
                                                                    bodyTotalComissaoGerente
                                                                }
                                                                style={{
                                                                    backgroundColor:
                                                                        '#f8f9fa'
                                                                }}
                                                            />
                                                        </DataTable>
                                                    )}
                                                </>
                                            )}
                                        </>
                                    )}
                                </div>
                            </Paper>
                        </>
                    )}
                </Formik>
            </div>
        </>
    );
}
